<template>

    <div class="page">

        <header-band v-show="isDesktop" :title="$t('menu_help')" :back="true" @eventBack="eventBack"></header-band>

        <div class="help">

            <div class="global" v-show="isGlobal">

                <div class="header" v-show="!isDesktop">

                    <div class="foxy">
                        <img src="/img/foxy/chest.png">
                    </div>

                    <span class="title-baseSemibold">{{ $t('menu_help') }}</span>

                </div>

                <div class="body">

                    <div class="news" v-show="newFeatures.length">
                        <div class="top">
                            <span class="text-lMedium">{{ $t('help_new') }}</span>
                            <img src="/img/icons/stars-blue-2.svg" class="img__32">
                        </div>

                        <div class="one-news" v-show="newFeatures.length === 1"></div>

                        <div class="multiple-news" v-show="newFeatures.length > 1">
                            <div class="new" v-for="feature in newFeatures" @click="goFeature(feature.index)">
                                <help-miniature :type="feature.name"></help-miniature>
                                <span class="text-lRegular mt__8">{{ $t(feature.title) }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="separator" v-show="!isDesktop"></div>

                    <div class="old">
                        <p class="text-xlSemibold">{{ $t('help_title_sorting') }}</p>

                        <div class="old-row">
                            <div class="feature" v-for="feature in oldFeatures" @click="goFeature(feature.index)">
                                <help-miniature :type="feature.name"></help-miniature>
                                <p class="text text-lMedium">{{ $t(feature.title) }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="separator" v-show="!isDesktop"></div>

                    <div class="static">

                        <p class="text-xlSemibold">{{ $t('global_faq') }}</p>

                        <div class="feature" @click="goFaq">
                            <img src="/img/help/faq.svg">
                            <p class="text text-lMedium">{{ $t('help_other_questions') }}</p>
                        </div>
                    </div>
                </div>

            </div>

            <div class="infos" v-show="isInfos">

                <div>
                    <div class="header-infos" v-show="!isDesktop">

                        <div @click="goAllFeatures">
                            <img src="/img/icons/arrow-blue.svg" class="img__20 mr__4">
                            <span class="text-baseSemibold color__aquamarine">{{ $t('global_back') }}</span>
                        </div>

                    </div>

                    <div class="infos-text">

                        <help-symbol :symbol="focusedFeature.name"></help-symbol>

                        <p class="text-xlSemibold title">{{ $t(focusedFeature.title) }}</p>

                        <markdown class="text-baseRegular mt__16" :text="$t(focusedFeature.text1)"></markdown>

                        <p class="text-baseRegular mt__8">{{ $t(focusedFeature.text2) }}</p>

                    </div>

                    <div class="image-container">
                        <help-carousel v-if="showCarousel"></help-carousel>
                        <help-poster :type="focusedFeature.name" v-else></help-poster>
                    </div>
                </div>

                <div class="footer" :class="{'footer-border': showFooterBorder}">
                    <div class="element">
                        <div class="left" v-if="prevFeature" @click="goPrevFeature">
                            <div class="round-blue">
                                <img src="/img/newsletters-v2/little-arrow-left-white.svg">
                            </div>
                            <span class="text-baseMedium color__aquamarine noselect">{{ $t(prevFeature.title) }}</span>
                        </div>
                    </div>
                    <div class="element">
                        <div class="right" v-if="nextFeature" @click="goNextFeature">
                            <span class="text-baseMedium color__aquamarine">{{ $t(nextFeature.title) }}</span>
                            <div class="round-blue">
                                <img src="/img/newsletters-v2/little-arrow-right-white.svg">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import ENUM from '../../assets/ENUM'

import HeaderBand from '../../components/headers/HeaderBand'
import HelpCarousel from '../../components/help/HelpCarousel'
import HelpMiniature from '../../components/help/HelpMiniature'
import HelpPoster from '../../components/help/HelpPoster'
import HelpSymbol from '../../components/help/HelpSymbol'
import Markdown from '../../components/Markdown'


export default {

    // HelpContent is a in a BottomSheetHelp for mobile and in a HelpPage for desktop

    name: 'help-content',

    components: {
        HeaderBand,
        HelpCarousel,
        HelpMiniature,
        HelpPoster,
        HelpSymbol,
        Markdown
    },

    computed: {
        allFeatures() {
            return this.newFeatures.concat(this.oldFeatures)
        },

        focusedFeature() {
            return this.allFeatures[this.featureIndex]
        },

        isGlobal() {
            return !this.showOnlyOneFeature
        },
        isInfos() {
            return this.showOnlyOneFeature
        },
        prevFeature() {
            if (this.featureIndex > 0) {
                return this.allFeatures[this.featureIndex - 1]
            } else {
                return false
            }
        },
        nextFeature() {
            if (this.featureIndex <= this.allFeatures.length - 1) {
                return this.allFeatures[this.featureIndex + 1]
            } else {
                return false
            }
        },
        newFeatures() {
            return this.features.filter(feature => feature.new)
        },
        oldFeatures() {
            return this.features.filter(feature => !feature.new)
        },

        showCarousel() {
            return this.focusedFeature.name === ENUM.HELP.FEATURES.ACTIONS
        },

        showFooterBorder() {
            return this.focusedFeature.name === ENUM.HELP.FEATURES.ACTIONS
        }

    },

    data() {
        return {
            showOnlyOneFeature: false,
            featureIndex: 0,
            ENUM_FEATURES: {
                SORT_DURING_SCAN: 'sort_during-scan',
                DELETED_MAILS: 'new_deleted_mail',
                NEW_SENDERS: 'new_senders',
                SORT_LATER: 'sort_later',
                REVERSE_ACTION: 'reverse_action',
                ACTIONS: 'actions'
            },
            features: [
                {
                    index: 0,
                    name: ENUM.HELP.FEATURES.SORT_DURING_SCAN,
                    title: 'help_sort_during_scan',
                    text1: 'help_sort_during_scan_text',
                    text2: 'help_find_information',
                    new: true
                },
                {
                    index: 1,
                    name: ENUM.HELP.FEATURES.DELETED_MAILS,
                    image: '/img/help/deleted-mails/new-mail-image.svg',
                    title: 'help_new_deleted_mail',
                    text1: 'help_new_deleted_mail_text',
                    text2: 'help_find_information',
                    new: true
                },
                {
                    index: 2,
                    name: ENUM.HELP.FEATURES.NEW_SENDERS,
                    image: '/img/help/new-sender/new-sender-image.svg',
                    title: 'help_new_senders',
                    text1: 'help_new_senders_text',
                    text2: 'help_find_history',
                    new: true
                },
                {
                    index: 3,
                    name: ENUM.HELP.FEATURES.SORT_LATER,
                    image: '/img/help/sort-later/sort-later-image.svg',
                    title: 'help_sort_later',
                    text1: 'help_sort_later_text',
                    text2: 'help_icon_identify',
                    new: true
                },
                {
                    index: 4,
                    name: ENUM.HELP.FEATURES.REVERSE_ACTION,
                    image: '/img/help/history/history-image.svg',
                    title: 'help_reverse_action',
                    text1: 'help_title_sorting_text',
                    text2: 'help_find_history',
                    new: true
                },
                {
                    index: 5,
                    name: ENUM.HELP.FEATURES.ACTIONS,
                    image: '/img/help/actions/actions-image.svg',
                    title: 'help_sorting_actions',
                    text1: '',
                    text2: '',
                    new: false
                }
            ]
        }
    },

    methods: {
        goFeature(index) {
            this.featureIndex = index
            this.showOnlyOneFeature = true
        },
        goAllFeatures() {
            this.showOnlyOneFeature = false
        },
        goPrevFeature() {
            this.featureIndex--
        },
        goNextFeature() {
            this.featureIndex++
        },
        eventBack() {
            this.showOnlyOneFeature
                ? this.goAllFeatures()
                : this.$router.go(-1)
        },
        goFaq() {
            this.$router.push({path: '/faq'})
        }
    }


}

</script>

<style lang="scss" scoped>

.page {
    height: 100%;
    @media screen and (min-width: $above-tablet-length) {
        display: flex;
        flex-direction: column;
        flex: 1;
    }

    .help {
        display: flex;
        flex-direction: column;
        width: 100%;
        overflow-y: scroll;
        height: 100%;

        @media screen and (min-width: $above-tablet-length) {
            align-items: center;
            justify-content: center;
            background-color: $timberwolf;
            flex: 1;
            overflow-y: visible;
        }

        .global {
            @media screen and (min-width: $above-tablet-length) {
                width: 100%;
                max-width: 864px;
                margin-top: 99px;
            }

            .header {
                padding: 16px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;

                .foxy {
                    width: 48px;
                    height: 48px;
                    border-radius: 48px;
                    display: flex;
                    background-color: $alice-blue;
                    align-items: flex-end;
                    justify-content: center;
                    margin-right: 12px;

                    > img {
                        height: 40px;
                    }
                }

            }

            .body {

                @media screen and (min-width: $above-tablet-length) {
                    background-color: $timberwolf;
                    padding: 32px;
                }

                .news {
                    padding: 16px;
                    margin: 0 16px;
                    border-radius: 24px;
                    background-color: $alice-blue;
                    overflow-x: scroll;

                    @media screen and (min-width: $above-tablet-length) {
                        margin-top: 104px;
                        padding: 32px;
                        align-items: center;
                        overflow: hidden;
                    }

                    .top {
                        margin-bottom: 24px;
                        display: flex;
                        align-items: center;


                        > img {
                            margin-left: 6px;

                            &:lang(ar-sa) {
                                margin-left: 0;
                                margin-right: 6px;
                            }
                        }
                    }
                }

                .multiple-news {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 16px 8px;

                    @media screen and (min-width: $above-tablet-length) {
                        //grid-template-columns: repeat(4, 1fr); /* 4 colonnes de largeur égale */
                        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
                        gap: 24px;
                    }

                    .new {
                        display: flex;
                        flex-direction: column;
                        text-align: center;
                        max-width: 150px;
                        cursor: pointer;

                        @media screen and (min-width: $above-tablet-length) {
                            max-width: 182px;
                        }
                    }
                }

                .separator {
                    margin: 16px 0;
                    width: 100%;
                    height: 1px;
                    background-color: $platinum;
                }

                .old {
                    display: flex;
                    flex-direction: column;
                    padding: 8px 16px;

                    @media screen and (min-width: $above-tablet-length) {
                        margin-top: 32px;
                        padding-left: 4px;
                        padding-right: 4px;
                        text-align: start;

                        > p {
                            padding: 0 16px;
                        }
                    }

                    .old-row {
                        @media screen and (min-width: $above-tablet-length) {
                            display: flex;
                            flex-direction: row;
                            flex-wrap: wrap;
                        }

                    }
                }

                .static {
                    display: flex;
                    flex-direction: column;
                    padding: 16px;
                    @media screen and (min-width: $above-tablet-length) {
                        display: flex;
                        text-align: start;
                        padding: 32px 4px 16px 4px
                    }
                }

                .feature {
                    padding-top: 16px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    cursor: pointer;
                    @media screen and (min-width: $above-tablet-length) {
                        flex-direction: column;
                        width: 25%;
                        padding-left: 12px;
                        padding-right: 12px;
                    }

                    > img {
                        width: 150px;
                        margin-right: 16px;
                        @media screen and (min-width: $above-tablet-length) {
                            margin: 0;
                            width: 100%;
                        }

                        &:lang(ar-sa) {
                            margin-right: 0;
                            margin-left: 16px;
                        }
                    }

                    .text {
                        width: 100%;
                        text-align: start;
                        @media screen and (min-width: $above-tablet-length) {
                            margin-top: 8px;
                        }
                    }
                }
            }
        }

        .infos {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            @media screen and (min-width: $above-tablet-length) {
                max-width: 500px;
                background-color: $white;
                border-radius: 24px;
                height: auto;
            }

            .header-infos {
                display: flex;
                width: 100%;
                padding: 8px 16px;
                border-bottom: 1px solid $platinum;
                @media screen and (min-width: $above-tablet-length) {
                    padding: 24px;
                }

                > div {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: flex-start;
                }
            }

            .infos-text {
                padding: 16px;
                display: flex;
                flex-direction: column;
                text-align: center;

                .title {
                    margin-top: 8px;
                    @media screen and (min-width: $above-tablet-length) {
                        margin-top: 16px;
                    }
                }
            }

            .image-container {
                width: 100vw;
                @media screen and (min-width: $above-tablet-length) {
                    width: auto;
                }
            }

            .footer {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                padding: 16px;

                .element {
                    flex: 1;
                    cursor: pointer;

                    .left {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: flex-start;
                        text-align: start;

                        > span {
                            margin: 0 8px;
                        }
                    }

                    .right {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: flex-end;
                        text-align: end;

                        > span {
                            margin: 0 8px;
                        }
                    }

                    .round-blue {
                        min-width: 28px;
                        height: 28px;
                        border-radius: 28px;
                        background-color: $aquamarine;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }
            }

            .footer-border {
                border-top: 1px solid $platinum;
            }
        }
    }
}

</style>
